// Sticky toolbar: hide on downscroll, show on upscroll
// Only active on collection pages (body has template-collection class)
(() => {
  if (!document.body.classList.contains('template-collection')) return;
  if (window.__BRUM_STICKY_TOOLBAR__) return;
  window.__BRUM_STICKY_TOOLBAR__ = true;

  const toolbar = document.querySelector('products-toolbar') || document.querySelector('.products-toolbar');
  if (!toolbar) return;

  let lastY = window.scrollY;
  let ticking = false;
  const THRESHOLD = 80; // px from top before hiding kicks in

  function onScroll() {
    const y = window.scrollY;
    if (y > lastY && y > THRESHOLD) {
      // Scrolling DOWN -> hide
      toolbar.classList.add('is-scrolled-down');
    } else if (y < lastY) {
      // Scrolling UP -> show
      toolbar.classList.remove('is-scrolled-down');
    }
    lastY = y;
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });
})();
